import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Progress } from '@/components/ui/progress';
import { Target, Gift } from 'lucide-react';

export const TipGoalsManager = () => {
  const [goals, setGoals] = useState([
    { id: 1, title: 'Extra Song', target: 500, current: 320, reward: '🎵 Sing fan favorite' },
    { id: 2, title: 'Q&A Session', target: 1000, current: 320, reward: '💬 Answer questions' },
  ]);
  const [newGoalTitle, setNewGoalTitle] = useState('');
  const [newGoalTarget, setNewGoalTarget] = useState(500);
  const [newGoalReward, setNewGoalReward] = useState('');

  const addGoal = () => {
    if (!newGoalTitle || !newGoalReward) return;
    
    setGoals([
      ...goals,
      {
        id: Date.now(),
        title: newGoalTitle,
        target: newGoalTarget,
        current: 0,
        reward: newGoalReward
      }
    ]);
    
    setNewGoalTitle('');
    setNewGoalTarget(500);
    setNewGoalReward('');
  };

  const removeGoal = (id: number) => {
    setGoals(goals.filter(g => g.id !== id));
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <Target className="h-5 w-5" />
          Tip Goals & Unlockables
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* Active Goals */}
        <div className="space-y-3">
          {goals.map((goal) => (
            <div key={goal.id} className="p-3 bg-muted rounded-lg space-y-2">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <Gift className="h-4 w-4 text-primary" />
                    <span className="font-medium">{goal.title}</span>
                  </div>
                  <p className="text-xs text-muted-foreground mt-1">{goal.reward}</p>
                </div>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => removeGoal(goal.id)}
                >
                  ×
                </Button>
              </div>
              <div className="space-y-1">
                <div className="flex justify-between text-xs">
                  <span>{goal.current} coins</span>
                  <span className="text-muted-foreground">{goal.target} goal</span>
                </div>
                <Progress value={(goal.current / goal.target) * 100} />
              </div>
            </div>
          ))}
        </div>

        {/* Add New Goal */}
        <div className="pt-4 border-t space-y-3">
          <Label>Add New Goal</Label>
          <Input
            placeholder="Goal title (e.g., Face reveal)"
            value={newGoalTitle}
            onChange={(e) => setNewGoalTitle(e.target.value)}
          />
          <Input
            placeholder="Reward description"
            value={newGoalReward}
            onChange={(e) => setNewGoalReward(e.target.value)}
          />
          <Input
            type="number"
            placeholder="Target coins"
            value={newGoalTarget}
            onChange={(e) => setNewGoalTarget(Number(e.target.value))}
            min="100"
          />
          <Button onClick={addGoal} className="w-full" size="sm">
            Add Goal
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};